import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Label from '../KeyComponents/Label';
import resizeIcon from './resize.svg';
import { Hint } from '../KeyComponents';

function TextArea(props) {
  const {
    className,
    label,
    state,
    required,
    info,
    value,
    placeholder,
    maxCharacters,
    onChange,
    hint,
    ...others
  } = props;

  const [typedCharacters, setTypedCharacters] = useState(0);

  const handleChange = (e) => {
    const inputText = e.target.value;
    if (inputText.length <= maxCharacters) {
      setTypedCharacters(inputText.length);
    }
    onChange(e.target);
  };

  return (
    <div className={classNames('pgn__textarea-wrapper', `pgn__textarea-wrapper-${state}`, className)} data-testid="textarea-wrapper">
      {label && <Label label={label} required={required} info={info} />}
      <div className="pgn__textarea-container">
        <textarea
          className={classNames('pgn__textarea')}
          {...others}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          disabled={state === 'disabled'}
          readOnly={state === 'readonly'}
          data-testid="textarea"
        />
        <div className="pgn__textarea-footer">
          <span className={classNames('pgn__textarea-text-size', { 'text-limit-reached': typedCharacters >= maxCharacters })}>{typedCharacters}/{maxCharacters}</span>
          <img src={resizeIcon} alt="resize" />
        </div>
      </div>
      {hint && <Hint error={state === 'error'}>{hint}</Hint>}
    </div>
  );
}

TextArea.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  maxCharacters: PropTypes.number,
  onChange: PropTypes.func,
  state: PropTypes.oneOf(['default', 'disabled', 'error', 'readonly']),
  className: PropTypes.string,
  required: PropTypes.bool,
  info: PropTypes.string,
  value: PropTypes.string
};

TextArea.defaultProps = {
  state: 'default',
  maxCharacters: 200,
  onChange: () => { },
  placeholder: 'Placeholder text...',
  label: null,
  className: '',
  required: false,
  info: null,
  value: ''
};

export default TextArea;
